export enum ClientAddressEntity {
  Transaction = 'Transaction',
  User = 'User',
  RetainingAgent = 'RetainingAgent',
}
